var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g, _path46, _g2, _path47, _g3, _path48, _g4, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIlluSignin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 564,
    viewBox: "0 0 564 564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1110_6195)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1110_6195",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -44,
    y: -44,
    width: 652,
    height: 652
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M608 -44H-44V608H608V-44Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1110_6195)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.729 72.075H521.054V508.824H45.729V72.075Z",
    fill: "#EFF3F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7068 63.052H272.091V493.485H74.7068V63.052Z",
    stroke: "#D0D3D4",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2178 246.626L262.581 76.2646V146.435L84.2178 316.796V246.626Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2178 342.242L262.581 171.881V191.929L84.2178 362.29V342.242Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2178 381.568L262.581 211.207V257.473L84.2178 427.834V381.568Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2178 440.174L262.581 269.813V309.91L84.2178 480.271V440.174Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M294.689 63.052H492.073V493.485H294.689V63.052Z",
    stroke: "#D0D3D4",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M304.2 246.626L482.563 76.2646V146.435L304.2 316.796V246.626Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M304.2 342.242L482.564 171.881V191.929L304.2 362.29V342.242Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M304.2 381.568L482.563 211.207V257.472L304.2 427.833V381.568Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M304.2 440.174L482.563 269.813V309.91L304.2 480.271V440.174Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7068 48.3008H272.091V52.1954H74.7068V48.3008Z",
    fill: "#D0D3D4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M294.689 48.3008H492.073V52.1954H294.689V48.3008Z",
    fill: "#D0D3D4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.12 286.544V525.357",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M459.079 286.544V525.357",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7119 275.214H478.073V286.548H88.7119V275.214Z",
    fill: "#D0D3D4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.976 275.213H463.992",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0908 418.091V525.359",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M509.109 418.091V525.359",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1064 406.757H522.679V418.09H44.1064V406.757Z",
    fill: "#D0D3D4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M485.24 406.757H74.7063",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M419.594 38.6418V90.0868",
    stroke: "#353640",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M419.595 103.773C424.678 103.773 428.799 107.894 428.799 112.977C428.799 118.06 424.678 122.181 419.595 122.181C414.512 122.181 410.391 118.06 410.391 112.977C410.391 107.894 414.512 103.773 419.595 103.773Z",
    fill: "#FFE072"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M419.595 90.0864L364.847 112.978H412.752H426.439H474.341L419.595 90.0864Z",
    fill: "#949899"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M364.847 112.979H466.083",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M419.596 92.4492L460.724 109.645",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2385 39.4543V66.4884",
    stroke: "#353640",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2412 80.1743C99.3244 80.1743 103.445 84.2952 103.445 89.3786C103.445 94.4616 99.3244 98.5824 94.2412 98.5824C89.1577 98.5824 85.0371 94.4616 85.0371 89.3786C85.0371 84.2952 89.1577 80.1743 94.2412 80.1743Z",
    fill: "#FFE072"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2389 66.4878L39.4927 89.3773H87.3971H101.083H148.987L94.2389 66.4878Z",
    fill: "#949899"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4927 89.3779H140.729",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2385 68.8484L135.369 86.046",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M447.583 482.464C448.062 483.373 447.714 484.498 446.805 484.977C445.897 485.455 444.773 485.105 444.293 484.199C438.516 473.238 431.746 469.066 425.822 469.024C420.786 468.987 416.287 471.93 413.56 476.181C410.808 480.465 409.872 486.061 411.986 491.279C414.807 498.243 423.062 504.604 439.642 506.642C440.661 506.766 441.389 507.697 441.266 508.718C441.142 509.737 440.211 510.465 439.19 510.341C421.01 508.105 411.813 500.763 408.535 492.677C405.934 486.256 407.07 479.404 410.428 474.173C413.808 468.909 419.454 465.267 425.835 465.312C433.024 465.362 441.057 470.08 447.583 482.464Z",
    fill: "#D43B3F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M491.413 497.867L534.279 464.505L540.988 468.047L500.649 516.328L491.413 497.867Z",
    fill: "#ED6056"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M441.652 463.48L429.725 508.119C429.725 508.119 422.922 525.357 440.722 525.357H488.433C506.233 525.357 499.428 508.119 499.428 508.119L487.501 463.48H464.576H441.652Z",
    fill: "#ED6056"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M464.576 460.78C477.237 460.78 487.501 461.989 487.501 463.481C487.501 464.973 477.237 466.182 464.576 466.182C451.916 466.182 441.652 464.973 441.652 463.481C441.652 461.989 451.916 460.78 464.576 460.78Z",
    fill: "#D43B3F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M465.276 509.789V502.428M465.276 502.428C465.276 502.428 466.395 491.99 476.925 490.221C476.925 490.221 471.613 512.493 452.229 497.395C452.229 497.395 458.753 495.997 465.276 502.428ZM465.276 502.428L465.276 495.158M465.276 495.158C465.276 495.158 470.961 491.246 465.276 483.324C465.276 483.324 459.684 489.101 465.276 495.158Z",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M542.525 463.067C548.899 465.104 553.289 468.501 552.328 470.652C551.372 472.802 545.428 472.895 539.054 470.857C533.229 468.994 529.063 465.999 529.12 463.854L529.117 463.848C528.831 461.453 529.25 459.551 529.25 459.551C529.25 459.551 532.568 460.859 534.549 461.6C536.837 461.657 539.636 462.142 542.525 463.067Z",
    fill: "#ED6056"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M542.524 461.476C548.896 464.535 553.286 468.633 552.327 470.63C551.369 472.626 545.426 471.765 539.053 468.706C532.681 465.647 528.291 461.548 529.25 459.552C530.208 457.555 536.151 458.417 542.524 461.476Z",
    fill: "#D43B3F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M371.142 480.432L360.686 487.511L367.597 525.357H375.925H387.09H395.418L402.329 487.511L391.875 480.432L381.509 480.849L371.142 480.432Z",
    fill: "#FF845E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M360.687 474.641H402.332C403.604 474.641 404.636 475.889 404.636 477.429V484.723C404.636 486.263 403.604 487.511 402.332 487.511H360.687C359.414 487.511 358.383 486.263 358.383 484.723V477.429C358.383 475.889 359.414 474.641 360.687 474.641Z",
    fill: "#FF845E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M402.329 487.511H360.686L367.597 525.357",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M365.738 476.464H402.33",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40869 525.357H557.376",
    stroke: "#353640",
    strokeWidth: 0.512907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1110_6195",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -44,
    y: -44,
    width: 652,
    height: 652
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-44 -44H608V608H-44V-44Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1110_6195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8994 355.222C39.8994 355.222 39.5495 369.734 50.8769 382.713C62.2021 395.692 86.0479 396.324 95.365 407.217C95.365 407.217 101.659 365.581 56.3276 361.875C56.3276 361.875 49.1056 357.815 39.8994 355.222Z",
    fill: "#42A268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3633 407.217C95.3633 407.217 101.657 365.58 56.3259 361.875C56.3259 361.875 84.3489 375.297 95.3633 407.217Z",
    fill: "#368F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.342 437.862C52.0116 448.335 42.7552 503.264 6.62158 468.727C6.62158 468.727 19.6072 470.968 25.9795 454.803C32.3495 438.638 46.7715 433.144 60.342 437.862Z",
    fill: "#61BB7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1448 459.443C42.2427 475.819 30.1153 491.183 6.62158 468.728C6.62158 468.728 16.545 475.915 31.7651 473.203C41.9817 471.381 47.5739 464.06 50.1448 459.443Z",
    fill: "#368F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.418 392.767C124.418 392.767 143.615 397.811 158.011 379.168C158.011 379.168 181.842 357.231 188.096 350.029C188.096 350.029 183.969 352.736 158.719 356.748C133.468 360.76 140.346 377.782 124.418 392.767Z",
    fill: "#368F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.777 387.579C130.777 387.579 137.834 382.589 155.179 384.832C172.525 387.075 187.74 378.469 188.096 350.029C188.096 350.029 171.851 365.928 158.793 372.664C145.736 379.399 137.134 383.745 130.777 387.579Z",
    fill: "#61BB7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.311 423.964C125.311 423.964 122.616 403.352 148.692 403.943C174.768 404.532 186.79 406.436 193.287 399.112C193.287 399.112 193.293 451.491 125.311 423.964Z",
    fill: "#42A268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.286 399.112C193.286 399.112 193.282 448.829 130.394 425.913C134.969 427.108 142.406 427.841 151.762 424.47C167.81 418.689 189.5 426.498 193.286 399.112Z",
    fill: "#368F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62085 468.727C6.62085 468.727 18.8937 481.94 45.3236 450.792C71.7535 419.642 102.667 431.676 102.667 485.009M102.667 485.009C102.667 485.009 120.604 379.29 39.8968 355.22M102.667 485.009C107.39 358.543 136.656 402.366 188.094 350.028M102.667 485.009C107.405 381.824 172.818 436.211 193.287 399.111",
    stroke: "#1F6A3D",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0806 475.934L76.1582 483.721L85.3625 525.356H96.4528H111.321H122.411L131.615 483.721L117.691 475.934L103.886 476.393L90.0806 475.934Z",
    fill: "#FF845E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1576 469.564H131.612C133.307 469.564 134.681 470.937 134.681 472.632V480.654C134.681 482.349 133.307 483.723 131.612 483.723H76.1576C74.4628 483.723 73.0889 482.349 73.0889 480.654V472.632C73.0889 470.937 74.4628 469.564 76.1576 469.564Z",
    fill: "#FF845E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8848 471.568H131.615",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6606 495.039L87.0345 489.571",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.41 495.039L87.0339 489.571",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.16 495.039L103.784 489.571",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4089 495.039L103.783 489.571",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.16 495.039L120.534 489.571",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.909 495.039L120.533 489.571",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6084 504.453L88.3346 499.411",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0592 504.453L88.3352 499.411",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.51 504.453L103.784 499.411",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0591 504.453L103.783 499.411",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.508 504.453L119.232 499.411",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.957 504.453L119.233 499.411",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5615 513.868L89.6357 509.25",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.709 513.868L89.6348 509.25",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.861 513.868L103.784 509.25",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7078 513.868L103.782 509.25",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.859 513.868L117.934 509.25",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 513.868L117.934 509.25",
    stroke: "#FBCC7C",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.615 483.721H76.1582L85.3625 525.356",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1110_6195",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -44,
    y: -44,
    width: 652,
    height: 652
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M-44 -44H608V608H-44V-44Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1110_6195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.077 225.974C403.077 225.974 395.251 198.514 406.648 172.555C418.042 146.598 421.847 131.421 415.262 117.837C415.262 117.837 422.647 125.23 425.834 142.207C429.022 159.185 411.067 162.162 411.786 183.826C412.506 205.492 413.613 216.896 403.077 225.974Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.656 248.196C336.656 248.196 348.722 255.043 359.164 226.157C369.606 197.271 387.876 188.464 400.448 221.072C400.448 221.072 394.747 212.152 384.811 216.265C374.873 220.378 359.408 263.503 336.656 248.196Z",
    fill: "#61BB7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.736 247.765C347.736 247.765 352.642 248.806 366.75 225.967C380.858 203.13 389.246 202.728 400.448 221.072",
    stroke: "#1F6A3D",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.867 134.127C341.867 134.127 351.741 156.658 376.954 168.74C402.165 180.824 396.116 214.796 398.944 223.623L403.034 223.607C403.034 223.607 403.533 198.694 394.047 173.569C384.561 148.441 348.819 145.423 341.867 134.127Z",
    fill: "#368F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.594 146.162C354.594 146.162 380.588 154.646 391.651 174.575C402.714 194.503 400.988 223.615 400.988 223.615",
    stroke: "#1F6A3D",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.717 222.131C404.717 222.131 405.788 204.467 427.854 194.899C449.917 185.33 472.583 175.77 474.954 158.017C474.954 158.017 466.326 162.126 453.347 161.598C440.37 161.069 402.568 166.489 404.717 222.131Z",
    fill: "#61BB7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.488 166.476C461.488 166.476 448.114 171.827 431.437 175.765C414.76 179.704 407.513 192.097 404.716 222.132",
    stroke: "#1F6A3D",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.142 224.284H388.463C388.463 224.284 367.875 243.953 379.037 275.212H403.142H427.246C438.408 243.953 417.82 224.284 417.82 224.284H403.141H403.142Z",
    fill: "#FF845E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.853 218.99H420.43C421.471 218.99 422.315 219.834 422.315 220.875V225.395C422.315 226.436 421.471 227.28 420.43 227.28H385.853C384.812 227.28 383.968 226.436 383.968 225.395V220.875C383.968 219.834 384.812 218.99 385.853 218.99Z",
    fill: "#FF845E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.272 227.278H387.018C387.018 227.278 369.26 241.359 379.037 275.211",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.469 230.674C420.469 230.674 432.053 246.85 426.661 269.62",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.958 220.887H420.171",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1110_6195",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 566,
    height: 566
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.306885 -0.306885H564.307V564.307H-0.306885V-0.306885Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1110_6195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.844 371.15H423.666V406.755H409.844V371.15Z",
    fill: "#D53B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.668 371.15H485.243V406.755H423.668V371.15Z",
    fill: "#ED6056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.667 371.15V406.756",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.205 374.503H482.098",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.802 298.966C402.802 298.966 408.252 312.578 409.303 321.792C410.353 331.007 436.325 337.908 445.759 359.269C455.19 380.627 451.396 312.142 402.802 298.966Z",
    fill: "#368F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.179 305.872C411.179 305.872 440.296 320.731 445.757 359.267",
    stroke: "#1F6A3D",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.284 358.615C460.284 358.615 470.536 356.939 479.2 363.465C487.868 369.992 508.199 365.677 517.406 367.913C517.406 367.913 500.806 333.121 460.284 358.615Z",
    fill: "#61BB7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.222 371.148C452.496 364.378 460.588 353.729 479.137 353.518C506.364 353.208 517.406 367.913 517.406 367.913",
    stroke: "#1F6A3D",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.693 371.14C446.601 369.709 444.563 334.731 464.649 320.638C485.157 306.249 510.367 300.72 510.367 300.72C510.367 300.72 497.905 308.513 492.886 323.529C487.872 338.533 459.367 342.347 446.719 371.14L446.693 371.14Z",
    fill: "#368F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.67 371.141C448.903 356.906 458.675 330.993 497.912 307.887",
    stroke: "#1F6A3D",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.573 382.105C401.573 382.105 401.986 355.402 412.144 353.515C422.302 351.628 435.706 356.021 435.706 356.021C435.706 356.021 443.979 352.881 447.855 357.485C451.729 362.092 449.322 367.33 434.348 368.171C419.374 369.011 401.573 382.105 401.573 382.105Z",
    fill: "#61BB7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.295 376.974C404.295 376.974 409.737 357.284 435.706 356.022",
    stroke: "#368F65",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1110_6195",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -44,
    y: -44,
    width: 652,
    height: 652
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M-44 -44H608V608H-44V-44Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1110_6195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.174 178.574L159.671 230.751M159.671 230.751L141.501 128.842M159.671 230.751L182.325 173.243",
    stroke: "#1F6A3D",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.737 150.987C124.737 150.987 119.542 141.551 104.203 142.741C88.8643 143.931 90.0521 155.966 90.0521 155.966C90.0521 155.966 98.8988 154.426 99.611 160.678C100.323 166.933 87.6983 166.703 87.6983 166.703C87.6983 166.703 84.718 172.243 82.0824 180.584C84.065 181.198 85.461 182.677 85.4621 184.407C85.4635 186.686 83.0349 188.538 80.0357 188.539L79.9487 188.537C78.2453 196.267 77.3729 205.256 78.9954 214.142C78.9954 214.142 88.9395 205.505 102.383 201.135C102.359 200.927 102.346 200.716 102.346 200.501C102.344 197.927 104.19 195.84 106.472 195.838C108.35 195.837 109.935 197.249 110.436 199.185C111.582 199.006 112.74 198.868 113.911 198.781C132.788 197.354 137.266 188.854 137.266 188.854C137.266 188.854 127.944 183.316 132.304 176.706C136.666 170.096 142.809 182.245 142.809 182.245C142.809 182.245 149.296 179.055 148.343 162.654C147.389 146.254 124.737 150.987 124.737 150.987Z",
    fill: "#61BB7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4137 205.762C82.4137 205.762 103.044 172.944 124.738 150.985M126.518 168.448L120.298 155.641L109.99 152.176M88.5296 178.028L104.803 174.069L110.484 186.984",
    stroke: "#1F6A3D",
    strokeWidth: 0.512907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.015 167.138C101.751 166.575 103.401 166.871 103.703 167.801C104.004 168.731 102.844 169.94 101.108 170.504C99.3717 171.068 97.7197 170.772 97.4192 169.842C97.1166 168.912 98.2785 167.702 100.015 167.138Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.519 179.834C125.195 183.119 124.319 186.071 122.561 186.435C120.803 186.797 118.828 184.431 118.152 181.148C117.477 177.865 118.351 174.91 120.111 174.549C121.869 174.185 123.842 176.552 124.519 179.834Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.029 153.624C110.19 154.764 111.449 156.626 110.839 157.784C110.229 158.943 107.982 158.958 105.819 157.82C103.656 156.681 102.396 154.819 103.008 153.66C103.618 152.501 105.863 152.487 108.029 153.624Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.521 188.712C100.344 186.966 102.166 185.787 103.594 186.075C105.018 186.366 105.508 188.01 104.683 189.754C103.861 191.498 102.038 192.677 100.612 192.391C99.1862 192.1 98.6962 190.453 99.521 188.712Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.557 173.249C182.557 173.249 187.214 165.346 199.671 166.203C212.126 167.059 210.621 177.09 210.621 177.09C210.621 177.09 203.475 175.885 202.616 181.099C201.756 186.312 212.062 186.01 212.062 186.01C212.062 186.01 214.246 190.596 216.021 197.518C214.379 198.048 213.175 199.291 213.097 200.731C212.994 202.631 214.891 204.149 217.337 204.125L217.408 204.124C218.451 210.544 218.762 218.021 217.044 225.435C217.044 225.435 209.318 218.332 198.549 214.809C198.578 214.635 198.599 214.46 198.608 214.281C198.725 212.138 197.312 210.415 195.453 210.435C193.921 210.451 192.565 211.64 192.069 213.257C191.143 213.119 190.204 213.013 189.255 212.951C173.923 211.929 170.65 204.891 170.65 204.891C170.65 204.891 178.502 200.196 175.24 194.73C171.976 189.264 166.425 199.434 166.425 199.434C166.425 199.434 161.276 196.837 162.786 183.172C164.295 169.507 182.557 173.249 182.557 173.249Z",
    fill: "#61BB7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.63 218.49C214.63 218.49 199.27 191.344 182.557 173.25M180.328 187.807L185.969 177.086L196.871 177.036M210.878 195.452L197.783 192.296L194.444 205.425",
    stroke: "#1F6A3D",
    strokeWidth: 0.512907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.807 206.106C186.15 207.469 187.886 207.983 188.686 207.253C189.486 206.522 189.048 204.828 187.707 203.467C186.364 202.104 184.628 201.591 183.828 202.32C183.028 203.049 183.466 204.744 184.807 206.106Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.138 184.833C197.687 185.619 199.54 185.191 200.278 183.876C201.017 182.561 200.358 180.858 198.809 180.075C197.257 179.288 195.405 179.717 194.668 181.031C193.93 182.346 194.587 184.047 196.138 184.833Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.901 189.998C183.24 191.945 183.502 193.843 184.484 194.236C185.466 194.629 186.795 193.37 187.456 191.424C188.116 189.477 187.854 187.579 186.874 187.185C185.892 186.792 184.562 188.051 183.901 189.998Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.902 199.689C208.488 198.675 207.482 197.999 206.66 198.176C205.835 198.354 205.505 199.316 205.922 200.328C206.336 201.341 207.341 202.018 208.164 201.841C208.989 201.662 209.319 200.698 208.902 199.689Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.501 128.839C141.501 128.839 142.42 115.445 152.347 108.952C162.274 102.456 173.651 115.006 173.651 115.006C173.651 115.006 168.644 118.952 172.265 123.588C175.883 128.226 182.046 122.052 182.046 122.052C182.046 122.052 197.308 136.665 194.482 156.13C194.482 156.13 184.837 150.163 174.314 154.529C163.793 158.894 154.54 157.714 154.54 157.714C154.54 157.714 157.978 153.356 153.789 146.575C149.602 139.794 144.403 153.688 144.403 153.688C144.403 153.688 122.781 139.848 141.501 128.839Z",
    fill: "#42A268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.131 140.162L150.72 129.033L163.067 120.485M175.245 144.013L169.069 133.691L176.14 131.074M186.426 146.494C186.426 146.494 172.53 127.458 141.503 128.837",
    stroke: "#1F6A3D",
    strokeWidth: 0.512907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.431 134.296C146.451 133.768 147.848 134.439 148.551 135.796C149.253 137.153 148.995 138.682 147.975 139.21C146.954 139.738 145.557 139.067 144.855 137.71C144.152 136.353 144.41 134.824 145.431 134.296Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.72 123.625C166.066 122.928 167.585 123.191 168.113 124.211C168.642 125.232 167.979 126.624 166.633 127.32C165.288 128.017 163.769 127.754 163.24 126.734C162.712 125.713 163.375 124.321 164.72 123.625Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.572 136.753C163.085 136.535 164.555 138.052 164.856 140.142C165.157 142.231 164.175 144.102 162.663 144.32C161.15 144.538 159.68 143.02 159.379 140.931C159.078 138.841 160.06 136.971 161.572 136.753Z",
    fill: "#1F6A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.864 225.789L131.941 233.576L141.145 275.213H152.236H167.104H178.194L187.398 233.576L173.474 225.789L159.669 226.25L145.864 225.789Z",
    fill: "#ED6056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.943 219.416H187.398C189.093 219.416 190.467 220.79 190.467 222.484V230.506C190.467 232.201 189.093 233.575 187.398 233.575H131.943C130.248 233.575 128.875 232.201 128.875 230.506V222.484C128.875 220.79 130.248 219.416 131.943 219.416Z",
    fill: "#ED6056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.399 233.576H131.942L141.146 275.213",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.668 221.425H187.398",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M206.791 479.828C206.791 479.828 194.875 499.87 194.875 525.357H357.468L345.547 484.546C296.823 464.088 250.677 463.323 206.791 479.828Z",
    fill: "#949899"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M206.791 479.828C206.791 479.828 204.078 484.392 201.242 491.929C224.036 501.681 284.948 521.547 346.786 488.787L345.547 484.546C299.875 464.484 253.637 462.413 206.791 479.828Z",
    fill: "#353640"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M343.811 495.968C343.811 495.968 339.327 512.487 317.144 520.275",
    stroke: "#353640",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M286.21 282.889C286.21 282.889 301.872 275.273 316.5 292.265C331.128 309.258 375.712 399.872 379.012 414.029C382.315 428.187 367.209 447.062 359.657 448.478C355.597 449.238 344.59 442.023 335.276 435.187C321.599 425.149 278.892 296.745 286.21 282.889Z",
    fill: "#FFE072"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M351.146 445.641C346.359 443.043 340.546 439.057 335.276 435.187C328.786 430.425 315.762 399.014 304.648 365.837C326.971 372.563 372.85 381.672 368.132 405.27L351.146 445.641Z",
    fill: "#2A1D19"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M219.494 286.515L203.336 286.542C173.872 288.168 218.245 446.931 206.798 479.817C240.747 495.574 303.793 508.918 345.554 484.561C323.69 426.608 343.495 324.627 286.399 284.048C280.396 294.041 241.999 288.442 219.494 286.515Z",
    fill: "#FFE072"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M336.194 443.171C331.341 406.851 330.771 364.942 319.15 331.074C304.225 381.585 317.365 438.898 336.194 443.171Z",
    fill: "#2A1D19"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M193.931 333.304C197.547 378.043 210.953 442.774 208.401 471.301C246.065 467.394 273.392 402.464 250.615 383.099C225.102 361.411 217.916 344.824 217.916 344.824L193.326 314.687C193.461 320.685 193.673 326.917 193.931 333.304Z",
    fill: "#2A1D19"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M267.866 468C267.866 468 291.698 470.365 310.11 453.498",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M328.764 449.962C328.764 449.962 324.51 468.422 308.643 476.242",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M232.94 298.454C232.94 298.454 256.537 316.157 276.829 315.689",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M238.261 244.163C238.261 244.163 242.427 267.464 233.472 281.946C230.959 286.013 224.224 286.14 219.493 286.513C219.493 286.513 274.355 318.966 279.548 311.181C284.742 303.396 286.397 284.046 286.397 284.046C286.397 284.046 278.57 287.781 274.082 286.448C269.906 285.208 277.447 260.551 270.709 257.733L238.261 244.163Z",
    fill: "#FCCAC3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M238.261 244.163C238.261 244.163 240.601 257.252 238.004 269.908C245.502 282.583 259.913 295.188 272.863 284.179C272.677 282.825 272.725 280.972 272.862 278.864C272.669 278.731 272.445 278.609 272.18 278.499C271.022 278.02 272.244 270.997 273.606 264.673C273.426 261.248 272.677 258.558 270.708 257.734L238.261 244.163Z",
    fill: "#2A1D19"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M307.827 353.839C304.52 347.191 301.872 338.214 303.676 328.026C303.676 328.026 301.61 311.985 305.786 307.372C308.159 304.748 309.697 310.731 310.581 316.382C317.977 312.331 329.999 308.878 329.999 308.878C329.999 308.878 331.19 333.102 328.866 341.96L329.327 343.097C319.795 344.862 311.228 351.097 307.827 353.839Z",
    fill: "#ED6056"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M328.125 306.953C328.125 306.953 322.054 308.334 321.768 310.575C321.483 312.819 329.679 311.723 329.679 311.723L329.464 316.679C329.464 316.679 323.328 316.823 322.157 319.01C320.985 321.199 326.776 322.944 326.776 322.944C326.776 322.944 322.475 324.494 322.719 326.911C322.964 329.329 327.645 329.83 327.645 329.83C327.645 329.83 324.974 330.914 324.508 332.154C324.041 333.395 325.471 336.575 331.07 334.9C336.668 333.226 335.232 328.69 335.232 328.69C335.232 328.69 337.96 322.991 334.013 321.928C334.013 321.928 336.763 321.075 337.643 319.95C338.523 318.825 336.726 315.795 336.074 315.267C335.422 314.74 331.97 314.369 331.97 314.369C331.97 314.369 334.172 311.941 334.634 309.638C335.096 307.335 333.527 305.749 328.125 306.953Z",
    fill: "#FCCAC3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M289.928 212.394C288.43 212.96 291.709 231.468 297.268 232.913C312.818 236.952 309.349 161.255 276.169 166.767C172.392 124.055 191.234 370.83 289.928 212.394Z",
    fill: "#2A1D19"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M297.606 246.439C294.523 256.406 282.556 279.76 267.916 283.09C253.276 286.42 237.069 273.955 224.644 252.723C212.219 231.491 225.399 189.34 256.597 178.044C300.466 162.158 306.005 219.28 297.606 246.439Z",
    fill: "#FCCAC3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M228.137 231.048C228.137 231.048 219.687 218.32 208.368 223.044C197.046 227.768 210.565 257.094 228.661 252.456C246.756 247.82 228.137 231.048 228.137 231.048Z",
    fill: "#FCCAC3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M209.792 233.148C209.792 233.148 220.574 229.319 228.3 240.707",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M214.05 239.243C214.05 239.243 216.07 235.748 222.025 234.65",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M225.057 178.7C181.068 121.004 161.666 229.377 158.707 230.399C158.707 230.399 176.059 249.454 189.559 235.581C189.559 235.581 191.774 184.996 212.779 184.816C233.786 184.639 225.057 178.7 225.057 178.7Z",
    fill: "#2A1D19"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M165.575 227.118C165.575 227.118 179.987 152.03 207.117 165.636",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M182.883 206.518C182.883 206.518 185.514 161.818 214.603 171.071",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M216.108 185.099C217.181 184.477 217.581 178.756 222.865 175.937C228.149 173.12 224.907 168.39 220.001 172.022C215.098 175.656 213.916 184.801 216.108 185.099Z",
    fill: "#D43B3F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M275.921 182.974C275.921 182.974 245.537 251.075 220.815 224.161C196.091 197.247 249.776 160.735 276.17 166.767C302.562 172.796 305.985 216.039 305.985 216.039C305.985 216.039 283.341 216.739 275.921 182.974Z",
    fill: "#2A1D19"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M277.299 176.106C277.299 176.106 268.966 200.077 289.745 212.595",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M269.634 181.653C269.634 181.653 259.519 209.574 238.814 221.939",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M278.888 234.44C278.888 234.44 279.866 245.445 282.278 251.503C282.278 251.503 279.195 254.992 272.922 252.96",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M260.792 252.382C260.792 252.382 263.582 262.388 279.237 260.958",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M263.972 261.727C263.972 261.727 265.364 264.695 270.148 264.781",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M295.629 239.725C296.52 241.585 294.642 242.327 293.751 240.466C293.747 240.455 291.773 236.464 287.636 238.012C286.823 238.313 285.919 237.901 285.616 237.088C285.316 236.275 285.728 235.369 286.543 235.069C293.326 232.528 295.62 239.705 295.629 239.725Z",
    fill: "#2A1D19"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M269.552 229.518C270.027 230.362 269.729 231.437 268.882 231.912C268.037 232.39 266.965 232.091 266.487 231.245C266.48 231.232 263.425 225.925 257.888 228.406C255.776 229.35 254.813 227.32 256.923 226.381C265.354 222.6 269.538 229.495 269.552 229.518Z",
    fill: "#2A1D19"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M273.037 219.441C273.037 219.441 255.695 218.435 254.249 216.758C252.805 215.082 263.036 213.803 267.53 214.315C272.024 214.828 276.348 219.436 273.037 219.441Z",
    fill: "#2A1D19"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M287.107 222.966C287.107 222.966 299.379 230.44 301.152 229.687C302.926 228.934 296.57 222.905 293.27 221.183C289.972 219.463 284.859 221.368 287.107 222.966Z",
    fill: "#2A1D19"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M310.766 276.608C310.766 276.608 313.074 265.534 318.644 265.524C324.213 265.517 317.059 278.233 310.766 276.608Z",
    fill: "#368F65"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M308.576 313.182C308.576 313.182 289.603 271.372 298.808 260.092C308.011 248.813 316.205 265.615 314.673 276.325C313.142 287.034 316.894 303.412 316.894 303.412C316.894 303.412 317.376 279.467 323.666 278.554C329.955 277.644 333.168 288.017 325.599 300.567C318.033 313.118 308.576 313.182 308.576 313.182Z",
    fill: "#1F6A3D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M301.283 274.594C301.283 274.594 297.986 264.984 289.704 264.847C281.422 264.707 293.269 280.296 300.73 279.801C300.73 279.801 302.93 278.246 301.283 274.594Z",
    fill: "#61BB7A"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M324.075 288.746C324.075 288.746 320.669 278.182 317.163 280.577C313.657 282.975 317.975 291.916 324.075 288.746Z",
    fill: "#61BB7A"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M292.095 265.168C292.095 265.168 299.846 266.883 301.889 277.341",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M317.924 280.251C319.593 281.505 323.06 283.902 324.075 288.746",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M298.038 285.303L300.998 286.609",
    stroke: "#368F65",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M303.29 259.869L302.938 262.701",
    stroke: "#61BB7A",
    strokeWidth: 0.512907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M310.506 263.434L309.804 266.335",
    stroke: "#61BB7A",
    strokeWidth: 0.512907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M310.705 274.576L313.663 275.881",
    stroke: "#368F65",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M306.353 282.604L309.313 283.91",
    stroke: "#368F65",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M311.481 287.535L311.129 290.367",
    stroke: "#61BB7A",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M305.385 270.368L305.03 273.198",
    stroke: "#61BB7A",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M327.302 280.735L326.95 283.567",
    stroke: "#61BB7A",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M326.753 290.582L329.71 291.89",
    stroke: "#368F65",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M319.363 292.786L321.149 291.745",
    stroke: "#368F65",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M297.291 299.031L330.449 299.894L325.917 344.032C317.065 345.936 308.264 345.685 299.52 343.345L297.291 299.031Z",
    fill: "#FF845E"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M298.312 305.548L323.023 306.192",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M219.256 313.078C219.256 313.078 216.549 286.189 203.452 285.713C190.353 285.239 169.332 294.69 168.383 320.648C167.433 346.604 186.301 466.471 225.474 461.289C236.65 452.805 250.631 432.798 234.755 396.144C229.169 378.152 225.046 347.258 219.256 313.078Z",
    fill: "#FFE072"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M182.784 405.681C182.784 405.681 194.916 456.504 217.695 460.657",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M224.917 346.234C224.917 346.234 228.793 378.093 234.755 396.144",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M213.96 320.413C213.96 320.413 214.895 362.416 225.745 395.923",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M377.158 426.716C373.494 437.36 364.413 447.141 359.073 448.167C355.103 448.927 344.445 442.08 335.233 435.416C323.694 415.22 317.122 392.549 306.273 355.15C306.273 355.15 311.705 348.08 331.128 343.21L367.362 404.922C367.362 404.922 375.235 414.163 377.158 426.716Z",
    fill: "#FFE072"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M367.362 404.924L331.128 343.21C315.452 345.831 306.273 355.15 306.273 355.15C306.273 355.15 317.829 404.342 335.29 435.457C335.29 435.457 346.536 444.303 354.86 447.391C363.183 450.48 370.058 442.096 377.16 426.718",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M332.013 352.575C332.013 352.575 349.265 384.738 355.199 393.446",
    stroke: "white",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M295.887 322.915C295.915 322.912 305.652 322.737 307.78 322.691C309.071 322.664 313.639 324.04 316.635 324.991C317.882 326.39 318.84 328.272 315.711 328.839L308.547 327.872L299.138 329.371C299.138 329.371 309.315 330.629 310.331 331.316C311.35 332.001 317.857 338.237 316.872 339.143C315.889 340.049 308.41 335.192 308.41 335.192L301.174 336.35C301.174 336.35 303.853 342.218 296.283 347.588C289.337 365.873 287.202 373.074 285.8 374.402C273.512 386.043 261.219 375.774 261.103 362.778C261.097 362.124 277.199 335.549 276.543 335.389C276.543 335.389 285.013 317.163 290.116 312.924C295.218 308.685 311.674 308.273 314.454 308.568C317.234 308.861 316.134 311.389 312.284 312.697C308.434 314.007 295.559 316.407 295.559 316.407C295.559 316.407 307.063 316.221 309.609 316.638C312.155 317.055 318.841 319.954 319.055 322.057C319.143 322.918 318.46 323.294 317.622 323.438C314.557 322.459 309.326 320.876 307.742 320.91C305.625 320.955 295.915 322.912 295.887 322.915Z",
    fill: "#FCCAC3"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M225.776 461.133C264.828 455.106 298.939 350.06 298.939 350.06C298.939 350.06 285.67 336.773 274.537 334.886L233.652 395.804C233.652 395.804 221.229 413.106 212.362 427.356C203.494 441.605 209.148 462.333 225.776 461.133Z",
    fill: "#FFE072"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M237.625 456.727C255.331 446.448 275.014 416.243 298.939 350.058C298.939 350.058 288.871 338.02 274.538 334.886L228.912 402.864",
    stroke: "#2A1D19",
    strokeWidth: 0.90628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1110_6195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 564,
    height: 564,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluSignin);
export default __webpack_public_path__ + "static/media/illu-signin.313b8036ed00617c778dba94b8efbeaa.svg";
export { ForwardRef as ReactComponent };